/**
 * Ключи для localStorage/sessionStorage
 * Единственный источник правды для storage keys
 */

/** 
 * Флаг "уже спрашивали пользователя про разрешение на уведомления"
 * Функция возвращает ключ с привязкой к masterId для изоляции между аккаунтами
 */
export const getNotificationsConsentAskedKey = (masterId: string) => 
  `minibook_notifications_consent_asked:${masterId}`;

/** @deprecated Используйте getNotificationsConsentAskedKey(masterId) */
export const NOTIFICATIONS_CONSENT_ASKED_KEY = 'minibook_notifications_consent_asked';

/** Состояние онбординга (текущий шаг, прогресс) */
export const ONBOARDING_STATE_KEY = 'minibook_onboarding_state';

/** Текущая тема оформления (light/dark/auto) */
export const THEME_KEY = 'minibook_theme';

/** Timestamp последнего открытия приложения (для smart refresh) */
export const LAST_OPENED_KEY = 'minibook_last_opened_at';

/** ID просмотренных записей (для скрытия уведомлений) */
export const VIEWED_APPOINTMENTS_KEY = 'minibook_viewed_appointments';

/** Название IndexedDB базы для кеша расписания */
export const SCHEDULE_CACHE_DB_NAME = 'minibook_schedule_cache';

/** Позиция скролла модалки календаря (восстановление при открытии) */
export const CALENDAR_SCROLL_TOP_KEY = 'minibook_calendar_scroll_top';

